module.exports = __webpack_public_path__ + "img/project-28.4ab8f2c3.png";